import { createFileRoute } from '@tanstack/react-router';
import { Unauthenticated } from 'convex/react';
import { lazy } from 'react';
import { LazyComponent as LazyWrapper } from '@/components/ui';

// Fallback to SignInPage for factor-one flow until a dedicated page exists
const SignInPage = lazy(() => import('../template/pages/SignInPage'));

const AuthFactorOneRoute = () => {
  return (
    <Unauthenticated>
      <LazyWrapper>
        <SignInPage />
      </LazyWrapper>
    </Unauthenticated>
  );
};

export const Route = createFileRoute('/auth/factor-one')({
  component: AuthFactorOneRoute,
});
